export default __webpack_public_path__ + "static/media/uprising.f5b1bff8.svg";